import { render, staticRenderFns } from "./previous-replies.vue?vue&type=template&id=e2d28296&scoped=true&"
import script from "./previous-replies.vue?vue&type=script&lang=js&"
export * from "./previous-replies.vue?vue&type=script&lang=js&"
import style0 from "./previous-replies.vue?vue&type=style&index=0&id=e2d28296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d28296",
  null
  
)

export default component.exports